import React, { useState, useEffect } from "react";
import { loadFooter, infoUtente } from "./Footer";
import { SunMoon } from "lucide-react";
import { useDarkMode } from "../../components/DarkModeContext";

const NavbarUtente = ({ page }) => {
    const { darkMode, toggleDarkMode } = useDarkMode();

    useEffect(() => {
        const footer = async () => {
            await loadFooter();
        };
        footer();
    }, []);

    return (
        <nav className="grid grid-cols-3 bg-gray-200 dark:bg-neutral-800 p-1 items-center">
            <img src={darkMode ? "/img/LogoLight.png" : "/img/LogoDark.png"} className="h-12" />
            <div className="flex justify-center font-semibold text-lg" onClick={() => window.location.reload()}>
                {page}
            </div>
            <div
                className="flex justify-end items-center pr-2 text-xs"
            >
                <span className="flex items-center hover:cursor-pointer" onClick={() => toggleDarkMode(true, infoUtente['ID'])}>
                    <SunMoon size={18} className="mr-1 text-blue-600 dark:text-blue-500" />
                    Cambia tema
                </span>
            </div>
        </nav>
    );
}
export default NavbarUtente;